import { render, staticRenderFns } from "./GraficoMapa.vue?vue&type=template&id=196d3dce&scoped=true&"
import script from "./GraficoMapa.vue?vue&type=script&lang=ts&"
export * from "./GraficoMapa.vue?vue&type=script&lang=ts&"
import style0 from "./GraficoMapa.vue?vue&type=style&index=0&id=196d3dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196d3dce",
  null
  
)

export default component.exports